/**
 * Shared app version — kept in sync with repo-root VERSION via scripts/bump-version.sh.
 * Build-time: VITE_APP_VERSION (Docker/CI) or package.json via vite.config define.
 */

export const APP_VERSION: string =
  (import.meta.env.VITE_APP_VERSION as string | undefined)?.trim() ||
  (typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0-dev')

export type VersionInfo = {
  service: string
  version: string
  environment?: string
  git_sha?: string | null
  build_id?: string | null
}

/** Static frontend version file (also available as GET /version.json). */
export async function fetchFrontendVersion(): Promise<VersionInfo> {
  const response = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' })
  if (!response.ok) {
    return { service: 'aries-frontend', version: APP_VERSION }
  }
  const data = (await response.json()) as Partial<VersionInfo>
  return {
    service: data.service ?? 'aries-frontend',
    version: data.version ?? APP_VERSION,
  }
}

/** Backend version endpoint (unauthenticated). */
export async function fetchBackendVersion(apiBase = '/api/v1'): Promise<VersionInfo> {
  const base = apiBase.replace(/\/$/, '')
  const response = await fetch(`${base}/version`, { cache: 'no-store' })
  if (!response.ok) {
    throw new Error(`version check failed: ${response.status}`)
  }
  return (await response.json()) as VersionInfo
}
